module.exports = __webpack_public_path__ + "images/img-3ufyXQ9.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/5.jpg
// module id = 2032
// module chunks = 0